import {Usage} from '../common/UsageSchema';
import {ExtractDeliveryNoteDocumentResult} from './ExtractDeliveryNoteDocumentResult';

export type ExtractDeliveryNoteDocumentUseCaseResult = {
  result: ExtractDeliveryNoteDocumentResult;
  usage: Usage;
};
